import { UpdateEntitesRattachementRequestDto } from 'lib_api/lib/api/gen';

export const newFourriereIdCorrelation: keyof UpdateEntitesRattachementRequestDto =
  'newFourriereIdCorrelation';
export const newAutoriteFourriereIdCorrelation: keyof UpdateEntitesRattachementRequestDto =
  'newAutoriteFourriereIdCorrelation';
export const newUniteFoIdCorrelation: keyof UpdateEntitesRattachementRequestDto =
  'newUniteFoIdCorrelation';
